/* import __COLOCATED_TEMPLATE__ from './sq-super-table-row.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attributeBindings, classNameBindings } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { and, not, or } from '@ember/object/computed';
import Component from '@ember/component';
let SqSuperTableRow = (_dec = classNameBindings(':table-row', 'isSelectable:table-row--selectable', 'row.isHeader:table-header', 'row.isHeader:super-table__header', 'row.isFooter:super-table__footer', 'row.isSelected:table-row--selectable-is-selected', 'row.isCollapsible:super-table-row--is-collapsible', 'row.isCollapsed:super-table-row--is-collapsed', 'row.isNested:super-table-row--is-nested', 'row.isBold:super-table-row--is-bold'), _dec2 = attributeBindings('style'), _dec3 = or('row.isHeader', 'row.isFooter'), _dec4 = not('isHeaderOrFooter'), _dec5 = and('row.isSelectable', 'notisHeaderOrFooter'), _dec6 = computed('row.{isCollapsed,isCollapsible}'), _dec7 = computed('cellAction', 'columns.[]', 'isTableCollapsible', 'row', 'sortDescending', 'sortProperty'), _dec(_class = _dec2(_class = (_class2 = class SqSuperTableRow extends Component {
  constructor(...args) {
    super(...args);
    // passed in
    _defineProperty(this, "columns", null);
    _defineProperty(this, "row", null);
    _defineProperty(this, "isTableCollapsible", false);
    _defineProperty(this, "sortProperty", null);
    _defineProperty(this, "sortDescending", null);
    _initializerDefineProperty(this, "isHeaderOrFooter", _descriptor, this);
    _initializerDefineProperty(this, "notisHeaderOrFooter", _descriptor2, this);
    _initializerDefineProperty(this, "isSelectable", _descriptor3, this);
  }
  get collapsibleRowClass() {
    if (!this.row.isCollapsible) {
      return null;
    }
    const caretClass = this.row.isCollapsed ? 'caret-right' : 'caret-down';
    return `caret ${caretClass}`;
  }

  // Note Currently all our report rows are immutable, if your content is editable then this could break.
  get cells() {
    const row = this.row;
    const sortProperty = this.sortProperty;
    const sortDescending = this.sortDescending;
    const isTableCollapsible = this.isTableCollapsible;
    return this.columns.map((column, index) => {
      const displayValue = column.getCellContent(row);
      const isCaretCell = index === 0 && isTableCollapsible;
      let cellClasses = column.getCellClasses(row);
      const cellTooltip = column.getCellTooltip(row);
      let caretSortingClass;
      if (!this.cellAction) {
        cellClasses += ' super-table-cell__no-action';
      }
      if (row.get('isHeader') && sortProperty && column.sortProperties === sortProperty) {
        if (sortDescending) {
          caretSortingClass = 'super-table-header-cell__caret-cell caret-up';
        } else {
          caretSortingClass = 'caret-down';
        }
      }
      return {
        displayValue,
        cellClasses,
        column,
        caretSortingClass,
        isCaretCell,
        cellTooltip
      };
    });
  }
  click(event) {
    this.action?.(this.row, event);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isHeaderOrFooter", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "notisHeaderOrFooter", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isSelectable", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "collapsibleRowClass", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "collapsibleRowClass"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cells", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "cells"), _class2.prototype), _class2)) || _class) || _class);
export { SqSuperTableRow as default };